export { default } from "/Users/dallin/code/kuali/builder-ui/terraria-db/app/routes/index.jsx";